import { render, staticRenderFns } from "./MsTooltip.vue?vue&type=template&id=0237679c&scoped=true"
import script from "./MsTooltip.vue?vue&type=script&lang=js"
export * from "./MsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237679c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0237679c')) {
      api.createRecord('0237679c', component.options)
    } else {
      api.reload('0237679c', component.options)
    }
    module.hot.accept("./MsTooltip.vue?vue&type=template&id=0237679c&scoped=true", function () {
      api.rerender('0237679c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/MsTooltip.vue"
export default component.exports